var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson")

function CheckPhoneEnabledWS(parent) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = 'CheckPhoneEnabledWS' + self.parent.id;			// Convenience name for debugging
  self.phoneEnabled = ko.observable(true);


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/location/' + self.parent.id + '/phoneEnabledForKiosk';
  });


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {IssueWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);
    var json = xmlToJson.parse(xmlData);

    self.phoneEnabled(json.true);

    // Return self (IssueWS) to be chainable, for best practice
    return self;
  };

  return self;
};

CheckPhoneEnabledWS.prototype = AbstractWS.prototype;
CheckPhoneEnabledWS.prototype.constructor = CheckPhoneEnabledWS;

module.exports = CheckPhoneEnabledWS
